import { AxiosResponse } from "axios";
import { IQuestionItem, IResponseQuestionsList } from "../../types/qas/qasQuestionTypes";
import { IResponse } from "../../types/statusTypes";
import { axiosApi } from "../../helpers";
import { ENDPOINTS_QAS, URL_QAS } from "../../constants/api_endpoints";

const approveQuestion = async (patchedQuestion: Partial<IQuestionItem>): Promise<IResponseQuestionsList | IResponse> => {
	try {
		const response: AxiosResponse<IResponseQuestionsList | IResponse> = await axiosApi.post(`${URL_QAS}/${ENDPOINTS_QAS.QUESTION_EDIT}/${patchedQuestion.id}`, {
			data: JSON.stringify(patchedQuestion),
		});
		return response.data;
	} catch (error) {
		throw new Error(error instanceof Error ? error.message : String(error));
	}
};

export default approveQuestion;
